const FindURL = (cot_id: string, targetId: number) => {
  switch (targetId) {
    case 0:
      return {
        url: `https://korean.visitkorea.or.kr/detail/ms_detail.do?cotid=${cot_id}`,
        source: '한국관광공사 - 대한민국 구석구석',
      };
    case 1:
      return {
        url: `https://korean.visitkorea.or.kr/detail/rem_detail.do?cotid=${cot_id}`,
        source: '한국관광공사 - 대한민국 구석구석',
      };
    case 2:
      return {
        url: `https://korean.visitkorea.or.kr/detail/cs_detail_cos.do?cotid=${cot_id}`,
        source: '한국관광공사 - 대한민국 구석구석',
      };
    case 3:
      return {
        url: `https://korean.visitkorea.or.kr/detail/fes_detail.do?cotid=${cot_id}`,
        source: '한국관광공사 - 대한민국 구석구석',
      };
    default:
      return {
        url: ``,
        source: '',
      };
  }
};

export default FindURL;
